import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { TitleRow } from "./TitleRow";
import "./ExpandablePanel.scss";

export interface IExpandablePanelProps {
    title: string;
    count?: string;
    isCollapsed?: boolean;
    class?: string;
    notColapsable?: boolean;
    onExpand?: () => void;
}

export const ExpandablePanel = (props: React.PropsWithChildren<IExpandablePanelProps>): JSX.Element => {
    const [isCollapsed, setIsCollapsed] = useState(props.isCollapsed);

    useEffect(() => {
        setIsCollapsed(props.isCollapsed);
    }, [props.isCollapsed]);

    useEffect(() => {
        !isCollapsed && props.onExpand?.();
    }, [isCollapsed]);

    function onClick() {
        setIsCollapsed(!isCollapsed);
    }

    return props.notColapsable ? (
        <>
            <div className="expandable-panel open">
                <TitleRow title={props.title}></TitleRow>
            </div>
            {props.children && <div className="collapsable open">{props.children}</div>}
        </>
    ) : (
        <>
            <div
                className={classnames("expandable-panel", "expandable", props.class, { open: !isCollapsed })}
                onClick={onClick}
            >
                <TitleRow title={props.title}></TitleRow>
                <div className="count-badge">
                    <span>{props.count}</span>
                </div>
                <div
                    className={classnames("icon-geolite-chevron-down", {
                        "rotate-x-180": !isCollapsed
                    })}
                ></div>
            </div>
            {props.children && (
                <div
                    className={classnames("collapsable", {
                        collapsed: isCollapsed,
                        open: !isCollapsed
                    })}
                >
                    {props.children}
                </div>
            )}
        </>
    );
};
